import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

export interface NativeProListHeaderState {
  isMapVisible: boolean;
  onToggleMap: () => void;
  mapShowLabel: string;
  mapHideLabel: string;
  mapShowAria: string;
  mapHideAria: string;
}

interface NativeProListHeaderContextValue {
  state: NativeProListHeaderState | null;
  setState: (state: NativeProListHeaderState | null) => void;
}

const NativeProListHeaderContext = createContext<NativeProListHeaderContextValue | null>(null);

export function NativeProListHeaderProvider({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<NativeProListHeaderState | null>(null);
  const value = useMemo(() => ({ state, setState }), [state]);
  return (
    <NativeProListHeaderContext.Provider value={value}>{children}</NativeProListHeaderContext.Provider>
  );
}

export function useNativeProListHeaderState(): NativeProListHeaderState | null {
  return useContext(NativeProListHeaderContext)?.state ?? null;
}

export function useNativeProListHeaderRegister(state: NativeProListHeaderState | null) {
  const setState = useContext(NativeProListHeaderContext)?.setState;

  useEffect(() => {
    if (!setState) return;
    setState(state);
    return () => setState(null);
  }, [setState, state]);
}
